import React, { useEffect, useRef, useState } from "react";
import HomeLoading from "./HomeLoading";
import LargeSlider from "./LargeSlider";
import Story from "./Story";
import FullBanner from "./FullBanner";
import { Link, useNavigate } from "react-router-dom";
import "../Style/home.css";
import CourseGrid from "./CourseGrid";
import VideoGrid from "./VideoGrid";
import PodcastGrid from "./PodcastGrid";
import TeachersList from "./TeachersList";
import BlogGrid from "./BlogGrid";
import { MyComponent, scrollToTop } from "./Methods";

export default function Home() {
  const [data, setData] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const firstLoading = useRef(true);
  const [showFullDesc, setShowFullDesc] = useState("");

  // setData({
  //   slider: [
  //     {
  //       mobile: "/image/minSlider.webp",
  //       tablet: "/image/midSlider.webp",
  //       desktop: "/image/largeSlider.webp",
  //       link: "/",
  //     },
  //   ],
  //   story: [
  //     {
  //       cover: "/image/storyCover.jpg",
  //       video:
  //         "https://dl.doomasdairy.com/content/1403/04/icecreamworldday2024.mp4",
  //       text: "",
  //       title: "متن نمایشی",
  //     },
  //   ],
  //   middleBanner: [
  //     {
  //       url: "",
  //       cover: "/image/middleBanner.webp",
  //       mobileCover: "/image/mobileMiddleBanner.webp",
  //       title: "something",
  //     },
  //   ],
  //   theLatestTrainingCourses: [
  //     {
  //       url: "/course/254",
  //       title: "نصب یونیتی ۶",
  //       teacher: "مدائنی",
  //       teacherId: "25",
  //       duration: "۰۱:۲۰:۰۰",
  //       price: 0,
  //       cover: "/image/courseImg.webp",
  //       discount: 40,
  //     },
  //   ],
  //   suggestedTrainingCourses: [
  //     {
  //       url: "/course/254",
  //       title: "کلاس آموزش هنرهای نمایشی",
  //       teacher: "مدائنی",
  //       teacherId: "25",
  //       duration: "۰۱:۲۰:۰۰",
  //       price: 0,
  //       cover: "/image/teatre.webp",
  //       discount: 40,
  //     },
  //   ],
  //   videos: [
  //     {
  //       videoLink: "/video/2",
  //       videoSrc: "/video/horizontalVideo.mp4",
  //       poster: "/image/videoCover.webp",
  //       teacherImg: "/image/teacherImg.webp",
  //       teacherName: "سعید راد",
  //       videoTitle: "آموزش تئاتر",
  //       teacherLink: "/teacher/212",
  //       duration: "۱۰:۰۰",
  //       visit: "22",
  //     },
  //   ],
  //   castVideo: [
  //     {
  //       videoLink: "/cast/2",
  //       videoSrc: "/video/horizontalVideo.mp4",
  //       poster: "/image/videoCover.webp",
  //       teacherImg: "/image/teacherImg.webp",
  //       teacherName: "سعید راد",
  //       videoTitle: "آموزش تئاتر",
  //       teacherLink: "/teacher/212",
  //       duration: "۱۰:۰۰",
  //       visit: "22",
  //     },
  //   ],
  //   podcasts: [
  //     {
  //       url: "/podcast/1",
  //       title: "پادکست شماره ۵",
  //       cover: "/image/podcastImg.jpg",
  //       duration: "۱۰:۰۰",
  //       src: "https://nicmusic.musicmelnet.com/nicmusic/032/061/bikalam%20molayem%20001.mp3",
  //       discount: 50,
  //       price: 100000,
  //     },
  //   ],
  //   teachers: [
  //     {
  //       name: "سعید راد",
  //       url: "1",
  //       cover: "/image/teacherImg.webp",
  //       expert: "متخصص داده",
  //       id: 1,
  //     },
  //   ],
  //   blogs: [
  //     {
  //       title: "عنوان وبلاگ",
  //       cover: "/image/blogCover.jpg",
  //       body: "خلاصه مختصر وبلاگ",
  //       url: "/blog/read_more_about_guitar",
  //       visit: 5,
  //       readTime: 5,
  //       date: "1402/04/05",
  //     },
  //     // تعداد مقالات ۴ تا باشد
  //   ],
  //   description:
  //     "<p>حسرت، یکی از سنگین‌ترین حس‌هایی که میشه باهاش روبه‌رو شد. این حس مثل یه سایه‌ست که همیشه پشت سرمون میاد، هر جا می‌ریم و هر تصمیمی که می‌گیریم، خودش رو بهمون یادآوری می‌کنه.</p><p>از همه بدتر اینکه درد حسرت تا سال‌ها با ما همراه می‌مونه. </p><a>مشاهده توضیحات</a><p>خلاصه کتاب حسرت و فرصت اثر دن سالیوان و بنجامین هاردی راهی برای بیشتر بهره‌بردن از زندگیه؛ اونم بدون اینکه اسیر حسرت‌هایی بشیم که شاید همین الان توی ذهنمون جا خوش کرده باشن.</p><p>این کتاب می‌خواد بهمون یاد بده که چطور می‌تونیم با تغییر ذهنیتمون، دیدگاه‌مون نسبت به موقعیت‌های مختلف زندگی رو تغییر بدیم. وقتی به جایی می‌رسیم که دو تا انتخاب داریم – یکی که راحت و بی‌خطره، و یکی دیگه که شاید ریسکی باشه ولی پتانسیل بزرگی برای موفقیت داره – سالیوان می‌گه باید به دومی فکر کنیم. چون هر چی بیشتر به سمت فرصت‌ها بریم، کمتر اسیر حسرت می‌شیم.</p><p>یه نکته جالب دیگه که سالیوان توی کتابش مطرح می‌کنه، اینه که حسرت‌ها همیشه از کارهایی که انجام ندادیم، شکل می‌گیرن. اون لحظه‌هایی که به جای اینکه دست به عمل بزنیم، نشستیم و تماشا کردیم؛ بنابراین اگه آدم عملگرایی نیستی اما توی سرت پر از ایده‌ها و فکره، حتما این کتاب می‌تونه خیلی کمکت کنه.</p><p>«حسرت و فرصت» کتابیه که بهمون کمک می‌کنه بفهمیم کجاها تو زندگی داریم از روی ترس عقب‌نشینی می‌کنیم و چطور می‌تونیم این عادت رو ترک کنیم. به قول سالیوان، زندگی پر از فرصت‌هاییه که فقط منتظرمون هستن، ولی باید جراتش رو داشته باشیم که بهشون نزدیک بشیم و ازشون استفاده کنیم. چون در نهایت، کسی که فرصت‌ها رو می‌قاپه، همونیه که کمتر اسیر حسرت‌ها میشه.</p>",
  //   aboutImg: "/image/videoCover.webp",
  // });

  useEffect(() => {
    document.title = "آموزشگاه هنری بامامیرسی";
    if (firstLoading.current) {
      firstLoading.current = false;
      const data = new FormData();
      data.append("name", "shanjan");
      data.append("password", "1234567890");
      fetch("https://crm.bamamiresi.com/Enrollment/GetHome", {
        method: "POST",
        body: data,
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("102");
          }
          return res.json();
        })
        .then((json) => {
          if (json.error) {
            throw new Error(json.msg);
          }
          setData(json[0]);
          setIsLoading(false);
          scrollToTop();
        })
        .catch((err) => {
          // navigate("/505");
        });
    }
  }, []);
  return (
    <>
      {loading ? (
        <HomeLoading />
      ) : (
        <>
          {data.slider && data.slider.length > 0 && (
            <LargeSlider data={{ slider: data.slider }} />
          )}
          {data.story && data.story.length > 0 && (
            <Story data={{ story: data.story }} />
          )}
          {data.middleBanner && data.middleBanner.length > 0 && (
            <FullBanner data={data.middleBanner[0]} />
          )}
          {((data.theLatestTrainingCourses &&
            data.theLatestTrainingCourses.length > 0) ||
            (data.suggestedTrainingCourses &&
              data.suggestedTrainingCourses.length > 0)) && (
            <section className="flex flexCol courseSection container">
              <div className="flex alignCenter justifyBetween sectionHeader">
                <h2 className="faFont textSize12 textClr3 rel sectionTitle flex alignCenter gap5">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 256 256"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M224,64,128,96,32,64l96-32Z" opacity="0.2"></path>
                    <path d="M226.53,56.41l-96-32a8,8,0,0,0-5.06,0l-96,32a8,8,0,0,0-5.4,6.75A5,5,0,0,0,24,64v80a8,8,0,0,0,16,0V75.1L73.59,86.29a64,64,0,0,0,20.65,88.05c-18,7.06-33.56,19.83-44.94,37.29a8,8,0,1,0,13.4,8.74C77.77,197.25,101.57,184,128,184s50.23,13.25,65.3,36.37a8,8,0,0,0,13.4-8.74c-11.38-17.46-27-30.23-44.94-37.29a64,64,0,0,0,20.65-88l44.12-14.7a8,8,0,0,0,0-15.18ZM176,120A48,48,0,1,1,89.35,91.55l36.12,12a8,8,0,0,0,5.06,0l36.12-12A47.89,47.89,0,0,1,176,120ZM128,87.57,57.3,64,128,40.43,198.7,64Z"></path>
                  </svg>
                  دوره های آموزشی
                </h2>
                <Link
                  to="/courses"
                  className="faFont textSize1 textClr3 sectionLink flex alignCenter gap5"
                >
                  همه دوره ها
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                    <path d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                  </svg>
                </Link>
              </div>
              {data.theLatestTrainingCourses &&
                data.theLatestTrainingCourses.length > 0 && (
                  <CourseGrid
                    data={data.theLatestTrainingCourses}
                    title={
                      <>
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 24 24"
                          height="1.2em"
                          width="1.2em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fill="none" d="M0 0h24v24H0z"></path>
                          <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2zm0 16H5V7h14v12zm-2-7H7v-2h10v2zm-4 4H7v-2h6v2z"></path>
                        </svg>
                        جدیترین دوره ها
                      </>
                    }
                  />
                )}
              {data.suggestedTrainingCourses &&
                data.suggestedTrainingCourses.length > 0 && (
                  <CourseGrid
                    data={data.suggestedTrainingCourses}
                    title={
                      <>
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 640 512"
                          height="1.5em"
                          width="1.5em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"></path>
                        </svg>
                        دوره های پیشنهادی
                      </>
                    }
                  />
                )}
            </section>
          )}

          {data.middleBanner && data.middleBanner.length > 1 && (
            <FullBanner data={data.middleBanner[1]} />
          )}
          {data.videos && data.videos.length > 0 && (
            <section className="flex flexCol container latestVideoSection">
              <VideoGrid
                data={data.videos}
                part={{
                  titleLogo: (
                    <svg
                      stroke="currentColor"
                      fill="none"
                      strokeWidth="0"
                      viewBox="0 0 15 15"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.76447 3.12199C5.63151 3.04859 6.56082 3 7.5 3C8.43918 3 9.36849 3.04859 10.2355 3.12199C11.2796 3.21037 11.9553 3.27008 12.472 3.39203C12.9425 3.50304 13.2048 3.64976 13.4306 3.88086C13.4553 3.90618 13.4902 3.94414 13.5133 3.97092C13.7126 4.20149 13.8435 4.4887 13.918 5.03283C13.9978 5.6156 14 6.37644 14 7.52493C14 8.66026 13.9978 9.41019 13.9181 9.98538C13.8439 10.5206 13.7137 10.8061 13.5125 11.0387C13.4896 11.0651 13.4541 11.1038 13.4296 11.1287C13.2009 11.3625 12.9406 11.5076 12.4818 11.6164C11.9752 11.7365 11.3143 11.7942 10.2878 11.8797C9.41948 11.9521 8.47566 12 7.5 12C6.52434 12 5.58052 11.9521 4.7122 11.8797C3.68572 11.7942 3.02477 11.7365 2.51816 11.6164C2.05936 11.5076 1.7991 11.3625 1.57037 11.1287C1.54593 11.1038 1.51035 11.0651 1.48748 11.0387C1.28628 10.8061 1.15612 10.5206 1.08193 9.98538C1.00221 9.41019 1 8.66026 1 7.52493C1 6.37644 1.00216 5.6156 1.082 5.03283C1.15654 4.4887 1.28744 4.20149 1.48666 3.97092C1.5098 3.94414 1.54468 3.90618 1.56942 3.88086C1.7952 3.64976 2.05752 3.50304 2.52796 3.39203C3.04473 3.27008 3.7204 3.21037 4.76447 3.12199ZM0 7.52493C0 5.28296 0 4.16198 0.729985 3.31713C0.766457 3.27491 0.815139 3.22194 0.854123 3.18204C1.63439 2.38339 2.64963 2.29744 4.68012 2.12555C5.56923 2.05028 6.52724 2 7.5 2C8.47276 2 9.43077 2.05028 10.3199 2.12555C12.3504 2.29744 13.3656 2.38339 14.1459 3.18204C14.1849 3.22194 14.2335 3.27491 14.27 3.31713C15 4.16198 15 5.28296 15 7.52493C15 9.74012 15 10.8477 14.2688 11.6929C14.2326 11.7348 14.1832 11.7885 14.1444 11.8281C13.3629 12.6269 12.3655 12.71 10.3709 12.8763C9.47971 12.9505 8.50782 13 7.5 13C6.49218 13 5.52028 12.9505 4.62915 12.8763C2.63446 12.71 1.63712 12.6269 0.855558 11.8281C0.816844 11.7885 0.767442 11.7348 0.731221 11.6929C0 10.8477 0 9.74012 0 7.52493ZM5.25 5.38264C5.25 5.20225 5.43522 5.08124 5.60041 5.15369L10.428 7.27105C10.6274 7.35853 10.6274 7.64147 10.428 7.72895L5.60041 9.84631C5.43522 9.91876 5.25 9.79775 5.25 9.61736V5.38264Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  ),
                  titleText: "ویدیوها",
                  linkLogo: (
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path fill="none" d="M0 0h24v24H0V0z"></path>
                      <path d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                    </svg>
                  ),
                  linkText: "همه ویدیو ها",
                  title: "videos",
                  preTemp: "vds",
                }}
              />
            </section>
          )}
          {data.castVideo && data.castVideo.length > 0 && (
            <section className="flex flexCol container latestVideoSection">
              <VideoGrid
                data={data.castVideo}
                part={{
                  titleLogo: (
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 512 512"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"></path>
                    </svg>
                  ),
                  titleText: "ویدیوکست ها",
                  linkLogo: (
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path fill="none" d="M0 0h24v24H0V0z"></path>
                      <path d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                    </svg>
                  ),
                  linkText: "همه ویدیو ها",
                  title: "casts",
                  preTemp: "cst",
                }}
              />
            </section>
          )}
          {data.middleBanner && data.middleBanner.length > 2 && (
            <FullBanner data={data.middleBanner[2]} />
          )}
          {data.podcasts && data.podcasts.length > 0 && (
            <PodcastGrid
              data={data.podcasts}
              part={{
                titleLogo: (
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    role="img"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1.503 9.678c-.83 0-1.5.67-1.5 1.5v1.63a1.5 1.5 0 103 0v-1.63c0-.83-.67-1.5-1.5-1.5zm20.994 0c-.83 0-1.5.67-1.5 1.5v1.63a1.5 1.5 0 103 0v-1.63c0-.83-.67-1.5-1.5-1.5zM6.68 14.587c-.83 0-1.5.67-1.5 1.5v1.63a1.5 1.5 0 103 0v-1.62c0-.83-.67-1.5-1.5-1.5zm0-9.817c-.83 0-1.5.67-1.5 1.5v5.357a1.5 1.5 0 003 0V6.258c0-.83-.67-1.5-1.5-1.5zm10.638 0c-.83 0-1.5.67-1.5 1.5v1.64a1.5 1.5 0 003 0V6.27c0-.83-.67-1.5-1.5-1.5zM12 0c-.83 0-1.5.67-1.5 1.5v1.63a1.5 1.5 0 103 0V1.5c0-.83-.67-1.499-1.5-1.499zm0 19.355c-.83 0-1.5.67-1.5 1.5v1.64a1.5 1.5 0 103 .01v-1.64c0-.82-.67-1.5-1.5-1.5zm5.319-8.457c-.83 0-1.5.68-1.5 1.5v5.328a1.5 1.5 0 003 0v-5.329c0-.83-.67-1.5-1.5-1.5zM12 6.128c-.83 0-1.5.68-1.5 1.5v8.728a1.5 1.5 0 003 0V7.638c0-.83-.67-1.5-1.5-1.5z"></path>
                  </svg>
                ),
                titleText: "پادکست ها",
                linkLogo: (
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                    <path d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                  </svg>
                ),
                linkText: "همه پادکست ها",
              }}
            />
          )}
          {data.teachers && data.teachers.length > 0 && (
            <TeachersList
              data={data.teachers}
              part={{
                titleLogo: (
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 640 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"></path>
                  </svg>
                ),
                titleText: "اساتید",
                linkLogo: (
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                    <path d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                  </svg>
                ),
                linkText: "همه اساتید",
              }}
            />
          )}
          {data.blogs && data.blogs.length > 0 && (
            <BlogGrid data={data.blogs} title={"آخرین مقالات"} hasMore={true} />
          )}
          {data.description ? (
            <section className="homeAboutSection grid container ">
              <div className="flex flexCol aboutSectionRightDiv">
                <div
                  className={`flex flexCol contentDescDiv rel ${showFullDesc}`}
                >
                  <h3 className="faFont textSize14 textClr3 flex alignCenter gap5 homeAboutTitle">
                    درباره ما بیشتر بدانید
                  </h3>
                  <div className="flex flexCol contentList faFont content rel">
                    {MyComponent({ htmlContent: data.description })}
                  </div>
                  <button
                    className="showFullDescription flex alignCenter faFont textSize9 textClr3"
                    onClick={() => setShowFullDesc("full")}
                  >
                    مشاهده بیشتر
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path fill="none" d="M0 0h24v24H0V0z"></path>
                      <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div className="flex flexCol homeAboutLeftDiv">
                <img
                  src={data.aboutImg}
                  alt="بامامی‌رسی"
                  className="homeAboutImg"
                  draggable="false"
                  width="100%"
                />
              </div>
            </section>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
}
